const initialState = {
  status: "invalid",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "PACKAGE_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "PACKAGE_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action,
      };
    case "PACKAGE_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
